import { upvote, cancelUpvote } from "@/api/api";

export default {
  data() {
    return {
      event_id: null,
      sort: true,
      upvoteRecords: [],
      UpvoteIdList: [],
    };
  },
  watch: {},
  mounted() {
    this.event_id = this.$route.query.event_id;
    // 在组件创建时尝试从 localStorage 获取 upvoteRecords
    this.loadUpvoteRecordsFromLocalStorage();
  },
  methods: {
    // 判断是否点赞
    onisUpvote(Val, index) {
      console.log(this.UpvoteIdList.includes(Val));
      if (this.UpvoteIdList.includes(Val)) {
        // 取消点赞
        this.onCancelUpvote(Val, index);
      } else {
        // 点赞
        this.onUpvote(Val, index);
      }
    },
    // 点赞
    async onUpvote(Val, index) {
      let { code, msg } = await upvote({
        id: Val,
      });
      if (code == 1) {
        this.UpvoteIdList.push(Val);
        if (index || index == 0) {
          this.$set(this.getlist, index, {
            ...this.getlist[index],
            upvote: this.getlist[index].upvote + 1,
          });
        } else {
          this.details.upvote = this.details.upvote + 1;
        }

        // 检查当前 event_id 是否与之前的所有 event_id 不同
        const isNewEvent = !this.upvoteRecords.some(
          (record) => record.event_id === this.event_id
        );
        // 如果是新 event_id，则添加新的记录
        if (isNewEvent) {
          const uniqueUpvoteIdList = this.UpvoteIdList.filter(
            (item, index) => this.UpvoteIdList.indexOf(item) === index
          );
          this.upvoteRecords.push({
            event_id: this.event_id,
            UpvoteIdList: uniqueUpvoteIdList,
          });
        } else {
          // 如果 event_id 已存在，则更新现有的 UpvoteIdList
          const existingRecordIndex = this.upvoteRecords.findIndex(
            (record) => record.event_id === this.event_id
          );
          const existingUpvoteIdList =
            this.upvoteRecords[existingRecordIndex].UpvoteIdList;

          // 合并新的 UpvoteIdList 到已存在的 UpvoteIdList
          const combinedUpvoteIdList = existingUpvoteIdList.concat(
            this.UpvoteIdList
          );
          const uniqueUpvoteIdList = combinedUpvoteIdList.filter(
            (item, index) => combinedUpvoteIdList.indexOf(item) === index
          );

          this.upvoteRecords[existingRecordIndex].UpvoteIdList =
            uniqueUpvoteIdList;
        }
        // 存储到 localStorage
        localStorage.setItem(
          "upvoteRecords",
          JSON.stringify(this.upvoteRecords)
        );
      } else {
        this.$message.warning(msg);
      }
    },
    // 取消点赞
    async onCancelUpvote(Val, index) {
      let { code, msg } = await cancelUpvote({
        id: Val,
      });
      if (code == 1) {
        // 查找与 event_id 匹配的记录索引
        const existingRecordIndex = this.upvoteRecords.findIndex(
          (record) => record.event_id === this.event_id
        );
        if (index || index == 0) {
          // 减少 upvote 计数
          this.$set(this.getlist, index, {
            ...this.getlist[index],
            upvote: this.getlist[index].upvote - 1,
          });
          // 强制更新视图
          this.$nextTick(() => {
            console.log("View updated");
          });
        } else {
          this.details.upvote = this.details.upvote - 1;
        }
        // 如果找到了匹配项
        if (existingRecordIndex !== -1) {
          // 获取对应的 UpvoteIdList
          const upvoteIdList =
            this.upvoteRecords[existingRecordIndex].UpvoteIdList;

          // 从 UpvoteIdList 中删除指定的 upvoteId
          this.upvoteRecords[existingRecordIndex].UpvoteIdList =
            upvoteIdList.filter((id) => id !== Val);
          // 存储到 localStorage
          localStorage.setItem(
            "upvoteRecords",
            JSON.stringify(this.upvoteRecords)
          );
          this.loadUpvoteRecordsFromLocalStorage()
        }
      } else {
        this.$message.warning(msg);
      }
    },
    // 获取存储的点赞记录
    loadUpvoteRecordsFromLocalStorage() {
      const storedRecords = localStorage.getItem("upvoteRecords");
      if (storedRecords) {
        this.upvoteRecords = JSON.parse(storedRecords);
        this.UpvoteIdList = Array.from(
          this.upvoteRecords.find((record) => record.event_id == this.event_id)
            ?.UpvoteIdList || []
        );
      }
    },
  },
};
